var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292904 1.70704C-0.0976348 1.31653 -0.0976348 0.683391 0.292904 0.292882C0.683444 -0.0976273 1.31663 -0.0976273 1.70717 0.292882L8.00008 6.58531L14.292 0.293836C14.6826 -0.0966731 15.3158 -0.0966734 15.7063 0.293836C16.0968 0.684345 16.0968 1.31749 15.7063 1.708L9.41435 7.99947L15.7063 14.291C16.0968 14.6815 16.0968 15.3146 15.7063 15.7051C15.3158 16.0956 14.6826 16.0956 14.292 15.7051L8.00008 9.41363L1.70717 15.7061C1.31663 16.0966 0.683444 16.0966 0.292904 15.7061C-0.0976348 15.3156 -0.0976348 14.6824 0.292904 14.2919L6.58582 7.99947L0.292904 1.70704Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.09e972368732712bff244abe724f15f8.svg";
export { ForwardRef as ReactComponent };